// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1a3Kv","title":"Header_title__34Rnp","left":"Header_left__3omyA","clinicName":"Header_clinicName__1pJh2"};